import styled from "styled-components";

export const Container = styled.div``;

export const Wrapper = styled.div`
  padding: 30px 40px;
  max-height: calc(100vh - 108px);
  overflow: auto;
  #severalListData {
    overflow: auto;
    max-height: 700px;
    white-space: pre;
    height: 85%;
    overflow: auto;
  }
  #severalListData ul {
    list-style: square;
  }
  #severalListData ul,
  #severalListData li {
    padding: 0px 0px 0px 18px;
    margin: 10px;
    vertical-align: middle;
    list-style: square;
  }
  #severalListData i {
    padding: 0px;
    margin: 0px;
    vertical-align: middle;
    color: grey;
    font-style: italic;
  }
  #zipContents {
    margin-top: 25px;
    .header {
      display: flex;
      align-items: center;
      max-width: 700px;
      justify-content: space-between;
      background: #6b5c4b;
      color: #fff;

      padding: 7px 15px;
      border-radius: 6px;
      h2 {
        font-size: 18px;
      }
      button {
        background-color: transparent;
        border: none;
        padding: 0;
      }
    }
    table {
      width: 100%;
      max-width: 700px;
      tr {
        background: var(--inner-section-bg);
        box-shadow: 0px 4px 4px rgb(0 0 0 / 5%);
        border-radius: 10px;
        margin-bottom: 5px;
        td {
          border: 1px solid var(--table-row-border-color);
          height: 50px;
          padding: 0 10px;

          :first-child {
            border-right: none;
            border-radius: 10px 0 0 10px;
          }
          :last-child {
            border-left: none;
            border-radius: 0 10px 10px 0;
            text-align: right;
          }
        }
        th {
          text-align: left;
          height: 50px;
          :last-child {
            text-align: right;
          }
        }
      }
    }
  }
`;

export const Header = styled.div`
  background: #6b5c4b;
  display: flex;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
  padding: 9px 40px;
  .bdr-btn {
    border: 1px solid #bc9b6a;
    border-radius: 6px;
    height: 30px;
    width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
  }
  .btn-wrapper {
    border: 1px solid #bc9b6a;
    border-radius: 6px;
    padding: 2px;

    button {
      background-color: transparent;
      color: #fff;
      font-size: 14px;
      border: none;
      padding: 4px 0;
      min-width: 46px;

      &.active {
        background: #bc9b6a;
        border-radius: 6px;
      }
    }
  }
  .rotate {
    animation: rotation 2s infinite linear;
  }
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  .bdr-rt {
    border-right: 1px solid #cdcfd0;
    padding-right: 15px;
  }
  .search-wrapper {
    height: 30px;
    width: 170px;
    display: flex;
    align-items: center;
    position: relative;

    input {
      height: 100%;
      width: 100%;
      background: #ffffff;
      border: 1px solid #cdcfd0;
      border-radius: 6px;
      padding: 0 30px 0 10px;
    }
    svg {
      position: absolute;
      right: 7px;
    }
  }
  .MuiSelect-select {
    font-size: 13px;
    padding: 3.5px 14px;
    background: #fff;
    /* color: #fff; */
  }
  /* .MuiInputBase-root:hover {
    .MuiOutlinedInput-notchedOutline {
      border-color: #fff;
    }
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #fff;
  }
  .MuiSvgIcon-root {
    path {
      fill: #fff;
    }
  } */
`;
